var BaseView = require('../../../components/accordion-list/content');
var AnalyticsDecorate = require('../../../../../analytics/decorate');
var FormatFactory = require('../../../../../factory/formats');
var GridThumbnailView = require('../../../components/thumbnail/grid');

module.exports = AnalyticsDecorate(require('../../analytics/grids'), BaseView.extend({
  apiCall: 'grid/fetch',
  columnWidth: INKIVE.C.IS_MOBILE ? 210 : 255,
  numberOfPhotos: 0,

  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.canvas = this.tool.editor.canvas;

    this.getFormat().then(_.bind(function () {
      this.setGridTemplateFormat();
      BaseView.prototype.initialize.call(this);
    }, this));
  },

  getFormat: function () {
    var deferred = $.Deferred();
    var getClosestFormat = _.bind(getCF, this);

    FormatFactory.getFormats().then(function (formats) {
      deferred.resolve(getClosestFormat(formats));
    });

    return deferred.promise();

    function getCF (formats) {
      var format;
      var sizeDifference = Infinity;
      var ratioDifference = Infinity;
      var width = this.canvas.contentW;
      var height = this.canvas.contentH;
      var ratio = width / height;

      _.each(formats, function (f) {
        var pixelFormat = convertToPixels(f);
        var sd, rd = Math.abs(ratio - pixelFormat.ratio);
        if (rd < ratioDifference) {
          sd = Math.abs(width - pixelFormat.width) + Math.abs(height - pixelFormat.height);
          if (sd < sizeDifference) {
            format = f;
            sizeDifference = sd;
            ratioDifference = rd;
          }
        }
      });

      return format;

      function convertToPixels (format) {
        var w = INKIVE.Helpers.convertUnitsToPixels(format['width'], format['unit']);
        var h = INKIVE.Helpers.convertUnitsToPixels(format['height'], format['unit']);

        return _.extend(format, { width: w, height: h, ratio: w / h });
      }
    }
  },

  loadData: function (repeat, end) {
    var onMoreData = _.partial(this.onMoreData, this.filterActionId);

    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));

    INKIVE.Helpers.sendCmd(
        INKIVE.C.BASE_URL + this.apiCall, this.getParams(), onMoreData
    );

    this.$el.find('.thumbnail-wrapper').css({ height: 'auto' });
  },

  getParams: function () {
    return _.extend({
      number_of_photos: ++this.numberOfPhotos
    }, this.size);
  },

  onMoreData: function (faId, result) {
    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    if (faId !== this.filterActionId) return;

    result = JSON.parse(result);
    var hasResults = result['STATUS'] === 'SUCCESS';

    if (hasResults) {
      this.appendGridThumbnails(result['MESSAGE']);
      this.repeat();
    } else {
      this.end();
    }

    this.scrollRefresh();
  },

  appendGridThumbnails: function (data) {
    var $scrollDetect = this.$el.find('.thumbnail-wrapper .scrollDetect');

    _.each(data, function (item) {
      var $thumbnailView = $('<div>').addClass('thumbnail grid')
          .insertBefore($scrollDetect);

      new GridThumbnailView({
        setCurrentPage: true,
        el: $thumbnailView,
        size: this.size,
        format: this.callFormat,
        data: item,
        numberOfPhotos: this.numberOfPhotos
      });
    }, this);
  },

  setGridTemplateFormat: function () {
    var thumbWidth = this.columnWidth;
    var canvas = this.tool.editor.canvas;

    this.callFormat = {
      width: canvas.contentW,
      height: canvas.contentH
    };

    this.size = {
      width: thumbWidth,
      height: thumbWidth * (this.callFormat.height / this.callFormat.width)
    };
  },

  getScrollHeight: function ($target) {
    var $tabContent = $target.closest('.tab-content.inner-tabs');
    var containerHeight = $tabContent.height();

    containerHeight -= $tabContent.find('.header-links').height();

    return containerHeight;
  }

}));
